import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { UpdateClientDto } from '@ansvar-sakerhet/api-client';
import { toast } from '../../../components/Toast';
import { clientKeys } from './clients.key';

export const useUpdateClient = (clientId: string) => {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const mutationFn = async (data: UpdateClientDto) => {
    const api = await getApi();
    const res = await api.clientsUpdate(clientId, data);

    return res.data;
  };

  const mutation = useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: clientKeys.all });
      toast.success('Klient uppdaterad');
    },
    onError: () =>
      toast.error('Ett fel uppstod när klienten skulle uppdateras'),
  });

  return mutation;
};
